import { EUserActionTypes } from '../../actions/user';
import { TReduxActions } from '../../types/redux';
import { IUser } from '../../types/user/user';

const defaultState: IUser = {
  isAuthenticated: false,
  permissions: {},
};

export function userReducer(state: IUser = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EUserActionTypes.SetUser: {
      return {
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
